import { ApiClient } from '../../core/api/ApiClient';
import { PointRepositoryImpl } from './implementations';
import { PointService } from './services';

export * from './implementations';
export * from './interfaces';
export * from './services';

class PointDomainContainer {
  constructor() {
    this._apiClient = null;
    this._pointRepository = null;
    this._pointService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
    }
    return this._apiClient;
  }

  get pointRepository() {
    if (!this._pointRepository) {
      this._pointRepository = new PointRepositoryImpl(this.apiClient);
    }
    return this._pointRepository;
  }

  get pointService() {
    if (!this._pointService) {
      this._pointService = new PointService(this.pointRepository);
    }
    return this._pointService;
  }

  reset() {
    this._apiClient = null;
    this._pointRepository = null;
    this._pointService = null;
  }
}

const container = new PointDomainContainer();

export const getPointService = () => container.pointService;
export const getPointRepository = () => container.pointRepository;
export const resetPointContainer = () => container.reset();
